import { useQuery } from '@tanstack/react-query';
import { getSubjectSeen, SubjectSeenMap } from '../queries/subjectSeen';

export function useSubjectSeen(slug?: string) {
  const { data, isPending, isError } = useQuery<SubjectSeenMap>({
    queryKey: ['subject-seen', slug],
    queryFn: () => getSubjectSeen(slug as string),
    enabled: !!slug,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });

  return { data: data ?? {}, isPending, isError };
}
